<template>
  <v-card class="GenGraph">
    <v-card-title class="titlegraphs">{{ title }}</v-card-title>
    <v-layout justify-end pb-2 pr-2>
      <v-flex xs3>
        <Toggle :modelValue="currentView" :theme="theme" @toggleValueChange="(val) => currentView = val">
          <v-btn flat value="graph">
            <span>{{ $t('Graph') }}</span>
            <v-icon>bar_chart</v-icon>
          </v-btn>
          <v-btn flat value="table">
            <span>{{ $t('Table') }}</span>
            <v-icon>table_chart</v-icon>
          </v-btn>
        </Toggle>
      </v-flex>
    </v-layout>
    <v-card v-show="currentView == 'graph'" class="Graph">
      <GlobalGraph v-if="graphSeries.length && xAxisData.length" :graphID="graphID" :series="graphSeries"
        :xAxisData="xAxisData" :yAxis="graphYAxis" :theme="theme" class="graph" />
    </v-card>
    <v-card v-show="currentView == 'table'" class="table-container">
      <v-data-table :headers="tableHeaders" :items="tableData" class="custom-table" hide-actions>
        <template v-slot:items="props">
          <td>{{ props.item.date }}</td>
          <td class="text-xs-center">
            <span :class="props.item.actual == 'N/A' ? 'error--text' : 'number--text'">{{ props.item.actual }}</span>
          </td>
          <td class="text-xs-center">
            <span :class="props.item.expected == 'N/A' ? 'error--text' : 'number--text'">{{ props.item.expected
              }}</span>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import GlobalGraph from "@/components/common/GlobalGraph";

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    graphSeries: {
      type: Array,
      default: function () {
        return []
      }
    },
    graphID: {
      type: [Number, String],
      default: 1
    },
    xAxisData: {
      type: Array,
      default: function () {
        return []
      }
    },
    graphYAxis: {
      type: Array,
      default: function () {
        return []
      }
    },
    theme: {
      type: String,
      default: 'dark'
    },
    tableHeaders: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      currentView: 'graph'
    }
  },
}
</script>

<style scoped>
.toggle-btn:disabled {
  background-color: #e0e0e0;
  color: #b0b0b0;
}

.table-container {
  max-height: 277px;
  overflow-y: auto;
}

.v-btn__content {
  background-color: var(--v-primary-base) !important;
  color: var(--primarytext);
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
}

.v-btn__content:hover {
  cursor: pointer;
}

.GenGraph {
  background-color: var(--v-primary-base) !important;
  color: var(--primarytext);
  border-radius: 10px;
  box-shadow: 0 5px 5px 0 #334079;
  height: 384px;
}

.Graph {
  height: 50px;
  background-color: var(--v-primary-base) !important;
  color: var(--primarytext);
  border-top: 1px solid #424242;
}

.graph {
  height: 270px;
  color: var(--primarytext);
  background-color: var(--v-primary-base) !important;
}

.activeButton .toggle-btn {
  color: var(--primarytext);
  background-color: var(--v-primary-base) !important;
}

.titlegraphs {
  text-align: center;
  color: var(--primarytext);
  font-size: 20px;
  display: flex;
  justify-content: center;
}

.custom-table {
  border: 1px solid #344079;
}

.custom-table td,
.custom-table th {
  border: 1px solid #344079;
  text-align: left;
}
</style>